import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line import/no-cycle
import Api from "../../lib/api";
import * as localStorage from "../../lib/localStorage";
import formateErrorsContent from "../../utils/formatErrorsContent";
import { extractResourceAttributes } from "../../utils/jsonApiUtils";
import { userRoles as currentUserRoles } from "../../constants/userRoles";
import trackAnalytics from "../../trackAnalytics";
import analytics from "../../analytics";

const accessTokenKey = "accessToken";
const authorizedActionsKey = "authorizedActions";
const userRolesKey = "userRoles";
const userIdKey = "userId";
const userFirstName = "firstName";
const userLastName = "lastName";
const userEmail = "email";

const initialState = {
    accessToken: localStorage.getItem(accessTokenKey),
    authorizedActions: localStorage.getItem(authorizedActionsKey),
    userRoles: localStorage.getItem(userRolesKey),
    userId: localStorage.getItem(userIdKey),
    firstName: localStorage.getItem(userFirstName),
    lastName: localStorage.getItem(userLastName),
    email: localStorage.getItem(userEmail),
    isLoading: false,
    apiErrors: null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        loginStart: (state) => {
            state.isLoading = true;
        },
        loginSuccess: (state, { payload }) => {
            const { token, entities } = payload;
            state.accessToken = token;

            localStorage.setItem(accessTokenKey, token);

            const { authorizedActions, userRoles, id, firstName, lastName, email } =
                extractResourceAttributes(entities.adminUsers);

            state.authorizedActions = authorizedActions;
            state.userRoles = userRoles;
            state.userId = id;
            state.firstName = firstName;
            state.lastName = lastName;
            state.email = email;
            localStorage.setItem(authorizedActionsKey, authorizedActions);
            localStorage.setItem(userRolesKey, userRoles);
            localStorage.setItem(userIdKey, id);
            localStorage.setItem(userFirstName, firstName);
            localStorage.setItem(userLastName, lastName);
            localStorage.setItem(userEmail, email);

            state.apiErrors = null;
            state.isLoading = false;
        },
        loginFailure: (state, { payload }) => {
            const formattedContent = formateErrorsContent(payload);
            state.apiErrors = formattedContent;
            state.isLoading = false;
        },
        logoutSuccess: (state) => {
            state.accessToken = null;
            state.authorizedActions = null;
            state.userRoles = null;
            trackAnalytics("Successful loggedOut");
            localStorage.removeItem(accessTokenKey);
            localStorage.removeItem(authorizedActionsKey);
            localStorage.removeItem(userRolesKey);
            localStorage.removeItem(userFirstName);
            localStorage.removeItem(userLastName);
            localStorage.removeItem(userEmail);
        },
    },
});

export default authSlice.reducer;

export const { loginStart, loginSuccess, loginFailure, logoutSuccess } = authSlice.actions;
export const authSliceSelector = () => (state) => state.auth;
export const accessTokenSelector = () => (state) => state.auth.accessToken;
export const authorizedActionsSelector = () => (state) => state.auth.authorizedActions;
export const userRolesSelector = () => (state) => state.auth.userRoles;
export const userIdSelector = () => (state) => state.auth.userId;
export const isSuperAdmin = () => (state) => {
    const { userRoles } = state.auth;

    if (userRoles === "undefined" || userRoles === undefined || userRoles === "") {
        return null;
    }

    return state.auth.userRoles.some((role) => role === currentUserRoles.SUPERADMIN);
};
// TODO: all code using isSuperAdmin should relay on the getUserRoles function
export const getUserRoles = () => (state) => {
    const { userRoles } = state.auth;

    if (userRoles === "undefined" || userRoles === undefined || userRoles === "") {
        return null;
    }

    return state.auth.userRoles;
};
export function login(email, password) {
    return async (dispatch) => {
        dispatch(loginStart());
        try {
            const response = await Api.post("auth/sign_in", {
                admin_user: {
                    email,
                    password,
                },
            });
            const { token, entities } = response;
            const { id, firstName, lastName, userRoles, createdAt, updatedAt } =
                extractResourceAttributes(entities.adminUsers);
            if (token) {
                dispatch(loginSuccess(response));
                trackAnalytics("Successful Login");
                analytics.identify(id, {
                    name: `${firstName} ${lastName}`,
                    Email: email,
                    Rule: userRoles,
                    createdAt: createdAt.substring(0, 10),
                    updatedAt: updatedAt.substring(0, 10),
                });
            } else {
                trackAnalytics("Failure Login");
                throw new Error("Something went wrong make sure your email/password is correct");
            }
        } catch (error) {
            dispatch(loginFailure(error));
            trackAnalytics("Failure Login");
        }
    };
}

export const logout = () => (dispatch) => {
    dispatch(logoutSuccess());
};
